interface ExternalLinkProps {
  url: string;
  text?: string;
  onLinkClick?: (event: React.MouseEvent) => void;
  className?: string;
}

const defaultOnLinkClick = (event: React.MouseEvent) => {
  if (event.keyCode === 9) return true; // Skip tab key press, +accessibility

  event.stopPropagation(); // prevent parent events from firing
  return false;
};

function ExternalLink({
  url,
  text = '',
  onLinkClick = defaultOnLinkClick,
  className = '',
}: ExternalLinkProps) {
  return (
    <a
      href={url}
      onClick={onLinkClick}
      target="_blank"
      className={className}
      rel="noopener noreferrer"
    >
      {text || url}
    </a>
  );
}

export default ExternalLink;
